import React, { Component } from "react";
import styles from "../../assets/css/modules/shared/tab.css";

export default class TabbedNavigation extends Component {
  render() {
    return (
      <ol
        className={
          styles.tabProgress +
          " d-flex flex-row justify-content-center text-center"
        }
      >
        {this.props.tabs.map((tab, index) => (
          <li
            key={index}
            id={"tab" + index}
            className={tab.isActive ? styles.active : ""}
          >
            <span className={styles.stepCounter}>{index + 1}</span>
            <p>{tab.title}</p>
          </li>
        ))}
      </ol>
    );
  }
}
